import React from 'react';
import { TextField } from '@mui/material';

import { Widget, InlineEditorProps, InlineEditor } from './_InlineDraftEditor';
import { Unset } from '@utils';

export function NumberWidget(props: Widget<number | string | Unset>) {
  return (
    <TextField
      style={{ width: '80px' }}
      value={props.value}
      variant="standard"
      autoFocus={true}
      onBlur={props.onBlur}
      onChange={e => {
        props.onValueChange(e.target.value);
      }}
    />
  );
}

export const NumberInlineEditor = (
  props: InlineEditorProps<string | number>
) => {
  return <InlineEditor {...props} widget={NumberWidget} valueType="number" />;
};
